import React, { useState, useEffect } from "react";
import { Table, Button, Input, Select, Upload, Checkbox, Space } from "antd";
import {
  EditOutlined,
  UploadOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import API from "../../../utils/api"; // Uvoz API instancu
import { toast } from "react-toastify";

const { Option } = Select;

const EditProduct = () => {
  const [products, setProducts] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [editProduct, setEditProduct] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ 1. Povlačenje proizvoda iz baze
  const fetchProducts = async () => {
    try {
      const { data } = await API.get("/products");
      setProducts(data);
    } catch (error) {
      toast.error("Greška pri učitavanju proizvoda!");
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // ✅ 2. Otvaranje edit moda
  const toggleExpand = (key) => {
    setExpandedRowKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );

    const product = products.find((p) => p.id === key);
    setEditProduct(product || null);
  };

  // ✅ 3. Ažuriranje proizvoda
  const handleSave = async () => {
    if (!editProduct) return;

    try {
      setLoading(true);
      await API.put(`/products/${editProduct.id}`, editProduct);
      toast.success("Proizvod uspešno ažuriran!");
      fetchProducts();
      setExpandedRowKeys([]);
    } catch (error) {
      toast.error("Greška pri ažuriranju proizvoda!");
    } finally {
      setLoading(false);
    }
  };

  // ✅ 4. Upload novih slika
  const handleUploadImage = async (file, productId) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      await API.post(`/products/${productId}/upload-image`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Slika uspešno dodata!");
      fetchProducts();
    } catch (error) {
      toast.error("Greška pri upload-u slike!");
    }
  };

  // ✅ 5. Postavljanje glavne slike
  const handleSetMainImage = (index, productId) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? {
              ...product,
              images: product.images.map((img, i) => ({
                ...img,
                isMain: i === index,
              })),
            }
          : product
      )
    );
  };

  // ✅ Kolone tabele
  const columns = [
    {
      title: "Slika",
      dataIndex: "image",
      key: "image",
      render: (image) =>
        image ? <img src={image} alt="Product" width={50} /> : "N/A",
    },
    {
      title: "Naziv proizvoda",
      dataIndex: "name",
      key: "name",
    },
    { title: "Cena", dataIndex: "price", key: "price" },
    { title: "Kategorija", dataIndex: "category", key: "category" },
    { title: "Stanje na lageru", dataIndex: "stock", key: "stock" },
    {
      title: "Akcije",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          icon={
            expandedRowKeys.includes(record.id) ? (
              <UpOutlined />
            ) : (
              <EditOutlined />
            )
          }
          onClick={() => toggleExpand(record.id)}
        >
          {expandedRowKeys.includes(record.id) ? "Zatvori" : "Uredi"}
        </Button>
      ),
    },
  ];

  return (
    <div>
      <h2>Uredi proizvode</h2>

      {/* Tabela proizvoda */}
      <Table
        columns={columns}
        dataSource={products}
        rowKey="id"
        expandable={{
          expandedRowKeys,
          expandedRowRender: (record) => (
            <div
              style={{
                padding: "15px",
                background: "#f9f9f9",
                borderRadius: "5px",
              }}
            >
              <h4>Naziv proizvoda</h4>
              <Input
                value={record.name}
                onChange={(e) =>
                  setEditProduct({ ...editProduct, name: e.target.value })
                }
              />

              <h4>Cena</h4>
              <Input
                value={record.price}
                onChange={(e) =>
                  setEditProduct({ ...editProduct, price: e.target.value })
                }
              />

              <h4>Kategorija</h4>
              <Select
                style={{ width: "100%" }}
                value={record.category}
                onChange={(value) =>
                  setEditProduct({ ...editProduct, category: value })
                }
              >
                <Option value="Gaming oprema">Gaming oprema</Option>
                <Option value="Kuhinjski uređaji">Kuhinjski uređaji</Option>
                <Option value="Računari">Računari</Option>
              </Select>

              <h4>Stanje na lageru</h4>
              <Input
                value={record.stock}
                onChange={(e) =>
                  setEditProduct({ ...editProduct, stock: e.target.value })
                }
              />

              <h4>Upload slike</h4>
              <Upload
                customRequest={({ file }) => handleUploadImage(file, record.id)}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Dodaj sliku</Button>
              </Upload>

              <Button
                type="primary"
                onClick={handleSave}
                loading={loading}
                style={{ marginTop: "15px" }}
              >
                Sačuvaj izmene
              </Button>
            </div>
          ),
        }}
      />
    </div>
  );
};

export default EditProduct;
